import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import type { SortMode } from "@/lib/songs"

interface SortSelectProps {
  value: SortMode
  onChange: (value: SortMode) => void
}

const OPTIONS: { value: SortMode; label: string }[] = [
  { value: "title", label: "가나다순" },
  { value: "artist", label: "아티스트순" },
  { value: "random", label: "랜덤" },
]

export function SortSelect({ value, onChange }: SortSelectProps) {
  return (
    <Select value={value} onValueChange={(v) => onChange(v as SortMode)}>
      <SelectTrigger size="sm" aria-label="정렬 방식">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {OPTIONS.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
